import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  ChevronDown, 
  ChevronUp, 
  Calendar, 
  Users, 
  Award, 
  FileText, 
  Download,
  CheckCircle2,
  Target,
  Sparkles,
  RefreshCw,
  Building2,
  BookOpen
} from 'lucide-react';
import { Button } from '../../components/ui/button';

const HistoryPage = () => {
  const [expandedSection, setExpandedSection] = useState('committee-5');

  // Executive Committee Data from Google Doc
  const executiveCommittees = [
    {
      id: 1,
      title: 'प्रथम कार्यकारिणी',
      titleEn: 'First Executive Committee',
      tenure: '31 मई, 1987 से 17 जून, 1990',
      electionNote: 'चयनित / निर्वाचित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री अचलदास महादानजी धनदे', location: 'बिलासपुर', type: 'elected' },
        { position: 'मंत्री', name: 'श्री सुखदेवप्रसाद ईश्वरलालजी कीरी', location: 'जोधपुर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री भागचंद मूलचंदजी मामतोरा', location: 'डीसा', type: 'nominated' },
        { position: 'उप मंत्री', name: 'श्री आशाराम हीरालालजी छूंछा', location: 'बीकानेर', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री रामलाल टेलारामजी गिराछ', location: 'जोधपुर', type: 'nominated' },
      ],
      activities: [
        'समाज का सर्वे व 2500 परिवारों का विवरण दो निरदेशिकाओं में प्रकाशित। मंत्री श्री सुखदेवप्रसादजी कीरी के समर्पित प्रयासों का परिणाम था यह।',
        'खुला अधिवेशन। 400 समाज बंधुओं की उपस्थिति व 45 विद्वजनों द्वारा अभिव्यक्तियां।'
      ]
    },
    {
      id: 2,
      title: 'द्वितीय कार्यकारिणी',
      titleEn: 'Second Executive Committee',
      tenure: '17 जून, 1990 से 10 जून, 1993',
      electionNote: '18 जून, 1990 को प्रतिनिधि सम्मेलन में चयनित / निर्वाचित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री नारायणदास लक्ष्मणदास जी वारडे', location: 'अमरावती', type: 'elected' },
        { position: 'मंत्री', name: 'श्री आशाराम हीरालालजी छूंछा', location: 'बीकानेर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री लक्ष्मणदास खूबचंदजी बिछड़ा', location: 'मोहनगढ', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री बाबुलाल हीरालालजी छूंछा', location: 'जोधपुर', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री चितरंजन जेठमलजी भूत', location: 'बीकानेर', type: 'nominated' },
      ],
      activities: [
        'सिलाई प्रशिक्षण केंद्र व सिलाई मशीन वितरण।',
        'छात्रवृत्ति वितरण।',
        'सामाजिक व पारिवारिक मामलों का हल।'
      ]
    },
    {
      id: 3,
      title: 'तृतीय कार्यकारिणी',
      titleEn: 'Third Executive Committee',
      tenure: '11 जून, 1993 से...',
      electionNote: '11 जून, 1993 को चयनित / निर्वाचित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री बाबूलाल हीरालालजी छूंछा', location: 'जोधपुर', type: 'elected' },
        { position: 'मंत्री', name: 'श्री माणकलाल अर्जुनमलजी भूत', location: 'जोधपुर', type: 'elected' },
        { position: 'कोषाध्यक्ष', name: 'श्री तगाराम सोहनराजजी कीरी', location: 'जोधपुर', type: 'elected' },
      ],
      activities: [
        'सभाओं का आयोजन।',
        'मृत्युभोज बंद करवाने के प्रयास।',
        'शिक्षा व चिकित्सा के लिये सुविधायें।'
      ],
      note: 'अध्यक्ष श्री बाबूलालजी छूंछा व कोषाध्यक्ष श्री तगाराम कीरी का स्वर्गवास हो गया। मंत्री श्री माणकलालजी भूत अकेले पड़ गये व लम्बे समय तक महासभा निष्क्रिय रही। लेकिन समाज की राष्ट्रीय स्तर की गतिविधियां जारी रहीं। स्थानीय समाजों व अन्य संस्थाओं और व्यक्तियों ने शिक्षा व चिकित्सा क्षेत्र में सेवायें, सामूहिक विवाह, मैट्रीमोनियल सेवायें, श्री हिंगलाज मंदिरों की स्थापना, धर्मशाला निर्माण, छात्रावास भवन निर्माण आदि महत्वपूर्ण व समाजोपयोगी कार्य जारी रखे। युवाओं का केंद्रीय संगठन युवक परिषद् भी निष्क्रियता की भेंट चढ़ गयी। इसके द्वारा प्रकाशित हिंगलाजज्योति निजी स्तर पर प्रकाशित की जाने लगी।'
    },
    {
      id: 4,
      title: 'पुनर्गठित कार्यकारिणी (2022)',
      titleEn: 'Reconstituted Committee',
      tenure: '10 अप्रैल, 2022 से...',
      electionNote: '10.04.2022 को जोधपुर में अधिवेशन में चयनित / निर्वाचित / मनोनीत',
      members: [
        { position: 'अध्यक्ष', name: 'श्री बंशीधर चैनारामजी छूंछा', location: 'चैन्नई', type: 'elected' },
        { position: 'मंत्री', name: 'श्री कन्हैयालाल बूलचंदजी वारडे', location: 'जोधपुर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री कन्हैयालाल अगरचंदजी भूत', location: 'बाड़मेर', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री राधाकिशन पूनमचंदजी गिराछ', location: 'पोकरण', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री जेठानंद मेघराजजी कीरी', location: 'जोधपुर', type: 'nominated' },
      ],
      activities: [
        'अध्यक्ष श्री बंशीधरजी छूंछा ने भारत भर में भ्रमण कर एकता व संगठन का संदेश दिया।',
        'महासभा का पंजीकरण कराने का प्रयास किया गया लेकिन विद्यमान नाम से पंजीकरण न हो सका।',
        '30.12.2023 को ब्रह्मक्षत्रिय मारवाड़ी खत्री एसोसिएशन के नाम से पंजीकरण हुआ व पंजीकृत कार्यालय दिल्ली में स्थित हुआ।'
      ],
      registrationNote: 'पंजीकृत नियमावली की प्रतिलिपि यहां से डाउनलोड की जा सकती है।'
    },
    {
      id: 5,
      title: 'वर्तमान कार्यकारिणी (2024)',
      titleEn: 'Current Executive Committee',
      tenure: '29 सितंबर, 2024 से वर्तमान',
      electionNote: '29 सितंबर, 2024 को जोधपुर में साधारण सभा में चयनित / निर्वाचित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री जेठानंद मेघराजजी कीरी', location: 'जोधपुर', type: 'elected' },
        { position: 'मंत्री', name: 'श्री पुष्पकुमार झूमरलालजी भूत', location: 'जोधपुर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री तोलाराम गणेमलजी छूंछा', location: 'जोधपुर', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री जगदीश चुन्नीलालजी कीरी', location: 'बैंगलोर', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री गौतम रतनलालजी कीरी', location: 'बालोतरा', type: 'nominated' },
      ],
      activities: [
        '22.12.2024 को कार्यकारिणी की प्रथम बैठक संपन्न हुयी।',
        'विधान संशोधन समिति, परिचय सम्मेलन व सामूहिक विवाह समिति, समन्वय समिति व छात्रवृत्ति समिति का गठन किया गया।',
        'परिचय संगम 2025 का आयोजन किया गया।',
        'छात्रवृत्ति नीति पुनः लिखित की गयी।',
        'विधान संशोधन कर दिया गया।'
      ],
      isCurrent: true
    },
  ];

  // Objectives from 1987 Constitution
  const objectives1987 = [
    'समस्त मारवाड़ी ब्रह्मक्षत्रिय समाज में एकता स्थापित करना।',
    'राष्ट्र के अभिन्न अंग के रुप में समाज का विकास करना।',
    'सामाजिक झगड़ों का निष्पक्षता से निपटारा करना।',
    'समाजिक, सांस्कृतिक, आर्थिक व शैक्षणिक क्षेत्र में सर्वांगीण उन्नति करना।',
    'समाज में जागृति निर्माण कर कुरीतियों को दूर करना।',
    'समाज के आबालवृद्ध, अनाथ, उपेक्षित, असहाय व कमजोर अंगों की सहायता करना व उन्हें सम्मानित स्थान दिलवाना।'
  ];

  // Future Plans
  const futurePlans = [
    'डिजिटलाइजेशन को आगे बढाते हुये यह वेबसाइट जारी की जा रही है।',
    'परिवारों व समाजबंधुओं के डिजीटल रजिस्टर तैयार किये जायेंगे।',
    'संगठन में महिलाओं की भागीदारी सुनिश्चित करने का प्रयास किया जा रहा है।',
    'समाज में व्याप्त धड़ेबाजी व मनभेदों को दूर करने प्रयास रहेंगे।',
    'छिपी प्रतिभाओं को आगे लाने का काम होगा।',
    'स्थानीय इकाइयों, संस्थाओं द्वारा किये जाने वाले राष्ट्रीय स्तर के कार्यक्रमों में सहयोग व समन्वय का प्रयास रहेगा।',
    'छात्रों के लिये काऊंसलिंग का कार्यक्रम बनेगा।'
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="gradient-orange py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
            <a href="/" className="hover:text-white">Home</a>
            <span>›</span>
            <a href="/about" className="hover:text-white">About Mahasabha</a>
            <span>›</span>
            <span>History</span>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              History
            </h1>
            <p className="text-2xl text-white/90 leading-relaxed font-serif">
              महासभा से एसोसिएशन तक
            </p>
            <p className="text-lg text-white/80 mt-2">
              From Mahasabha to Association - Our Journey
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sub Navigation */}
      <div className="bg-white border-b border-gray-100 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-8 overflow-x-auto py-4">
            {[
              { id: 'origin', label: 'स्थापना' },
              { id: 'objectives', label: 'उद्देश्य' },
              { id: 'committees', label: 'कार्यकारिणी' },
              { id: 'amendments', label: 'संशोधन' },
              { id: 'future', label: 'भविष्य' }
            ].map((item, index) => (
              <button
                key={item.id}
                onClick={() => {
                  const element = document.getElementById(item.id);
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`text-sm font-medium whitespace-nowrap py-2.5 min-h-[40px] border-b-2 transition-colors ${
                  index === 0 
                    ? 'text-primary border-primary' 
                    : 'text-gray-600 border-transparent hover:text-primary'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Origin Section */}
        <motion.section
          id="origin"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="bg-white rounded-2xl border border-gray-100 shadow-card overflow-hidden">
            <div className="p-8">
              {/* Introduction */}
              <div className="prose prose-lg max-w-none mb-8">
                <p className="text-gray-600 leading-relaxed mb-6">
                  समाज में केंद्रीय संगठन की कल्पना काफी पुरानी रही है और भूतकाल में समय समय पर इस ओर प्रयास किये जाते रहे हैं। औपचारिक केंद्रीय संगठन के बनने से पूर्व भी समाज के सम्मेलन आयोजित होते रहे हैं व सामाजिक विषयों पर निर्णय लिये जाते रहे हैं।
                </p>
                <p className="text-gray-600 leading-relaxed">
                  1979 में स्थापित युवक मंडलों के केंद्रीय संगठन <strong className="text-gray-900">श्री ब्रह्मक्षत्रिय मारवाड़ी युवक परिषद्</strong> के अनुभवों व उसके द्वारा मासिक <strong className="text-gray-900">हिंगलाजज्योति</strong> के प्रकाशन के बाद आयी जागरूकता से समाज के अखिल भारतीय स्तर पर संगठन स्थापित की आवश्यकता और बलवती हुयी।
                </p>
              </div>

              {/* Formation - 1987 */}
              <div className="bg-gradient-to-br from-primary/5 to-transparent rounded-xl p-6 border-l-4 border-primary mb-8">
                <div className="flex items-center gap-2 mb-4">
                  <Calendar className="w-5 h-5 text-primary" />
                  <h3 className="font-bold text-xl text-gray-900">
                    30-31 मई, 1987 - महासभा की स्थापना
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4">
                  समाज के अग्रणी महानुभावों ने युवाओं को साथ लेते हुये समाज के केंद्रीय संगठन के लिये प्रयास तेज किये। अंततः <strong className="text-gray-900">30 व 31 मई, 1987</strong> को जोधपुर में सम्पन्न समस्त मारवाड़ी ब्रह्मक्षत्रिय समाज के सम्मेलन में <strong className="text-primary">अखिल भारतीय मारवाड़ी ब्रह्मक्षत्रिय महासभा</strong> की स्थापना हुयी।
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  सम्मेलन में समाज की <strong className="text-gray-900">51 पंचायतों व संस्थाओं</strong> के चुने हुये <strong className="text-gray-900">83 प्रतिनिधियों</strong> ने सर्वसम्मति से विधान पारित कर महासभा का गठन किया।
                </p>
                <p className="text-gray-600 leading-relaxed">
                  जोधपुर में हिंगलाज छात्रावास, युवक परिषद् के मुख्यालय रहे हैं और जोधपुर समाज भी अग्रणी व केंद्र में रहा है। तदनुसार महासभा का मुख्यालय भी जोधपुर में रहा। केंद्रीय संगठनों के सचिवालय जोधपुर में व अध्यक्ष अन्य स्थानों से होने की परम्परा रही है।
                </p>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Objectives Section */}
        <motion.section
          id="objectives"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-2 section-heading">
            1987 के विधान के अनुसार उद्देश्य
          </h2>
          <p className="text-gray-500 mb-8">Objectives as per the 1987 Constitution</p>

          <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-8">
            <div className="flex items-center gap-2 mb-6">
              <Target className="w-6 h-6 text-primary" />
              <h3 className="font-bold text-xl text-gray-900">राष्ट्रीय स्तर के इस संगठन के उद्देश्य</h3>
            </div>
            <div className="grid gap-3">
              {objectives1987.map((objective, index) => (
                <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                  <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{objective}</span>
                </div>
              ))}
            </div>

            {/* Download 1987 Constitution */}
            <div className="bg-primary/5 p-4 rounded-lg mt-6">
              <div className="flex items-start gap-3 mb-3">
                <FileText className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">1987 में पारित अखिल भारतीय मारवाड़ी ब्रह्मक्षत्रिय महासभा का विधान यहां से डाउनलोड कीजिये।</span>
              </div>
              <a 
                href="https://customer-assets.emergentagent.com/job_portal-updates-1/artifacts/s7jsq0tn_%E0%A4%AE%E0%A4%B9%E0%A4%BE%E0%A4%B8%E0%A4%AD%E0%A4%BE%20%E0%A4%B5%E0%A4%BF%E0%A4%A7%E0%A4%BE%E0%A4%A8%201987.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outline" size="sm" className="border-primary text-primary hover:bg-primary hover:text-white">
                  <Download className="w-4 h-4 mr-2" /> महासभा विधान 1987 डाउनलोड करें
                </Button>
              </a>
            </div>
          </div>
        </motion.section>

        {/* Executive Committees Section */}
        <motion.section
          id="committees"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-2 section-heading">
            कार्यकारिणी समितियां
          </h2>
          <p className="text-gray-500 mb-8">Executive Committees Timeline</p>

          <div className="space-y-4">
            {executiveCommittees.map((committee) => (
              <React.Fragment key={committee.id}>
              <div 
                className={`bg-white rounded-xl border overflow-hidden transition-all ${
                  committee.isCurrent ? 'border-primary shadow-glow' : 'border-gray-100 shadow-card'
                }`}
              >
                <div 
                  className={`p-6 cursor-pointer ${committee.isCurrent ? 'bg-primary/5' : 'hover:bg-gray-50'}`}
                  onClick={() => setExpandedSection(expandedSection === `committee-${committee.id}` ? '' : `committee-${committee.id}`)}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      {committee.isCurrent && (
                        <span className="inline-block bg-primary text-white text-xs font-bold px-3 py-1 rounded-full mb-2">
                          वर्तमान / Current
                        </span>
                      )}
                      <h4 className="font-bold text-lg text-gray-900">
                        {committee.title}
                      </h4>
                      <p className="text-sm text-primary font-medium">{committee.titleEn}</p>
                      <p className="text-sm text-gray-500 flex items-center gap-2 mt-1">
                        <Calendar className="w-4 h-4" />
                        कार्यकाल: {committee.tenure}
                      </p>
                    </div>
                    <div className="flex items-center gap-4">
                      <span className="text-sm text-gray-400 hidden sm:block">{committee.members.length} members</span>
                      {expandedSection === `committee-${committee.id}` ? (
                        <ChevronUp className="w-5 h-5 text-gray-400" />
                      ) : (
                        <ChevronDown className="w-5 h-5 text-gray-400" />
                      )}
                    </div>
                  </div>
                </div>

                {expandedSection === `committee-${committee.id}` && (
                  <div className="p-6 border-t border-gray-100 bg-gray-50/50">
                    {committee.electionNote && (
                      <p className="text-sm text-primary font-medium mb-4 bg-primary/5 p-3 rounded-lg">
                        {committee.electionNote}
                      </p>
                    )}

                    {/* Members Table */}
                    <div className="overflow-x-auto mb-6">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">पद</th>
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">नाम</th>
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">स्थान</th>
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">प्रकार</th>
                          </tr>
                        </thead>
                        <tbody>
                          {committee.members.map((member, idx) => (
                            <tr key={idx} className="border-b border-gray-100 last:border-0">
                              <td className="py-3 px-4 font-medium text-gray-900">{member.position}</td>
                              <td className="py-3 px-4 text-gray-700">{member.name}</td>
                              <td className="py-3 px-4 text-gray-500">{member.location}</td>
                              <td className="py-3 px-4">
                                <span className={`text-xs px-3 py-1 rounded-full font-medium ${
                                  member.type === 'elected' 
                                    ? 'bg-green-100 text-green-700' 
                                    : 'bg-blue-100 text-blue-700'
                                }`}>
                                  {member.type === 'elected' ? 'निर्वाचित' : 'मनोनीत'}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Activities */}
                    {committee.activities && committee.activities.length > 0 && (
                      <div className="mb-4">
                        <h5 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                          <Award className="w-4 h-4 text-primary" />
                          गतिविधियां:
                        </h5>
                        <ul className="space-y-2">
                          {committee.activities.map((activity, idx) => (
                            <li key={idx} className="flex items-start gap-3 text-sm text-gray-600">
                              <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0" />
                              {activity}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Registration Note with Download Links */}
                    {committee.registrationNote && (
                      <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg text-sm text-blue-800 mt-4">
                        <div className="flex items-center gap-2 mb-4">
                          <FileText className="w-4 h-4" />
                          <span className="font-medium">पंजीकृत नियमावली डाउनलोड करें:</span>
                        </div>
                        <div className="space-y-3">
                          <div>
                            <p className="text-gray-700 mb-2">Download Registered Rules and Regulations of Brahmakshatriya Marvadi Khatri Association dated 23.12.2023.</p>
                            <a 
                              href="https://customer-assets.emergentagent.com/job_portal-updates-1/artifacts/b5ktqrj6_Registered%20Rules%20and%20Regulations%2030122023.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Button variant="outline" size="sm" className="border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white">
                                <Download className="w-4 h-4 mr-2" /> Download (English)
                              </Button>
                            </a>
                          </div>
                          <div>
                            <p className="text-gray-700 mb-2">ब्रह्मक्षत्रिय मारवाड़ी खत्री एसोसिएशन की 23.12.2023 को पंजीकृत नियमावली (हिंदी रुपांतरण) यहां से डाऊनलोड कीजिये।</p>
                            <a 
                              href="https://customer-assets.emergentagent.com/job_portal-updates-1/artifacts/9hjaldpu_%E0%A4%8F%E0%A4%B8%E0%A5%8B%E0%A4%B8%E0%A4%BF%E0%A4%8F%E0%A4%B6%E0%A4%A8%20%E0%A4%95%E0%A5%80%20%E0%A4%AA%E0%A4%82%E0%A4%9C%E0%A5%80%E0%A4%95%E0%A5%83%E0%A4%A4%20%E0%A4%A8%E0%A4%BF%E0%A4%AF%E0%A4%AE%E0%A4%BE%E0%A4%B5%E0%A4%B2%E0%A5%80%202023%20%E0%A4%95%E0%A4%BE%20%E0%A4%B9%E0%A4%BF%E0%A4%82%E0%A4%A6%E0%A5%80%20%E0%A4%B0%E0%A5%81%E0%A4%AA%E0%A4%BE%E0%A4%82%E0%A4%A4%E0%A4%B0%E0%A4%A3.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Button variant="outline" size="sm" className="border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white">
                                <Download className="w-4 h-4 mr-2" /> डाउनलोड करें (हिंदी)
                              </Button>
                            </a>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Note */}
                    {committee.note && (
                      <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg text-sm text-yellow-800 mt-4">
                        <strong>नोट:</strong> {committee.note}
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {/* Revival Section - shown after तृतीय कार्यकारिणी (id: 3) */}
              {committee.id === 3 && (
                <div className="bg-gradient-to-br from-green-50 to-transparent rounded-2xl border border-green-100 p-8 my-4">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                      <RefreshCw className="w-6 h-6 text-green-600" />
                    </div>
                    <div>
                      <h3 className="font-bold text-xl text-gray-900">संध्या के बाद सवेरा</h3>
                      <p className="text-sm text-gray-500">The Revival</p>
                    </div>
                  </div>
                  
                  <div className="prose prose-lg max-w-none">
                    <p className="text-gray-600 leading-relaxed mb-4">
                      संध्या के बाद सवेरा होता ही है। निष्क्रयता के बाद सक्रियता आती है। कुछ सक्रिय कार्यकर्ता आगे आये व राष्ट्रीय स्तर पर समाज का संगठन बनाने का विचार रखा। चूंकि ऐसा संगठन पहले से है लेकिन निष्क्रिय है, को पुनः सक्रिय करने का विचार दिया गया।
                    </p>
                    <p className="text-gray-600 leading-relaxed mb-4">
                      <strong className="text-gray-900">श्रीमती ऊषा अनिलजी भूत, जैसलमेर, श्री छगनलाल हेमराजजी भूत, उदयपुर व श्री संतोषकुमार भीकचंदजी गिराछ, जोधपुर</strong> ने एक वॉट्सएप ग्रुप बनाया व महासभा को पुनः सक्रिय करने के लिये विचार विमर्श का मंच प्रदान किया।
                    </p>
                    <p className="text-gray-600 leading-relaxed mb-4">
                      भारी चर्चा व विमर्श के बाद सक्रियता का मार्ग प्रशस्त हुआ। मंत्री वयोवृद्ध <strong className="text-gray-900">श्री माणकलालजी भूत</strong> ने समाज के अनुभवी व वरिष्ठ समाजसेवी <strong className="text-gray-900">श्री ओमप्रकाश हिम्मतरामजी मांधु जोधपुर</strong> को नयी कार्यकारिणी गठित करने के लिये सम्मेलन बुलाने के लिये अधिकृत किया।
                    </p>
                    <p className="text-gray-600 leading-relaxed">
                      श्री माधु ने स्थानीय कार्यकर्ताओं के सहयोग से 10.04.2022 को जोधपुर में समाज का अधिवेशन आयोजित किया। पिछले वर्षों का प्रतिवेदन मंत्री की ओर से पेश किया। गहन विचार विमर्श के बाद एक वर्ष के लिये नयी कार्यकारिणी गठित करने का निर्णय किया गया।
                    </p>
                  </div>
                </div>
              )}
              </React.Fragment>
            ))}
          </div>
        </motion.section>

        {/* Amendments Section */}
        <motion.section
          id="amendments"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-2 section-heading">
            महासभा - एसोसिएशन - संशोधन
          </h2>
          <p className="text-gray-500 mb-8">Mahasabha - Association - Amendments</p>

          <div className="space-y-6">
            {/* Registration Info */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-6">
              <div className="flex items-center gap-3 mb-4">
                <Building2 className="w-5 h-5 text-primary" />
                <h3 className="font-bold text-lg text-gray-900">पंजीकरण</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                पंजीकरण के बाद साधारण सभा का अधिवेशन <strong className="text-gray-900">29 सितंबर, 2024</strong> को जोधपुर में सम्पन्न हुआ। पाया गया कि पंजीकृत नियमावली के अनुसार काम आगे बढाने व नयी कार्यकारिणी गठित में कठिनाई है। अतः पुराने विधान के अनुसार साधारण सभा व चुनाव सम्पन्न करवाये गये।
              </p>
            </div>

            {/* 14.09.2025 Assembly */}
            <div className="bg-gradient-to-br from-primary/5 to-transparent rounded-2xl border border-primary/20 p-6">
              <div className="flex items-center gap-3 mb-4">
                <Calendar className="w-5 h-5 text-primary" />
                <h3 className="font-bold text-lg text-gray-900">14.09.2025 को साधारण सभा - विधान संशोधन</h3>
              </div>
              <div className="prose prose-lg max-w-none text-gray-600">
                <p className="mb-4">
                  14.09.2025 को साधारण का अधिवेशन जोधपुर में सम्पन्न हुआ, जिसमें:
                </p>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2.5 flex-shrink-0" />
                    <span><strong>श्री लक्ष्मणदासजी बिछड़ा, रामगढ़</strong> को पद्मश्री सम्मान के लिये माननीय प्रधानमंत्री को लिखा गया नामांकन पत्र पढा गया।</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2.5 flex-shrink-0" />
                    <span><strong>डॉक्टर किशोरजी कीरी, जोधपुर</strong> की पुस्तक "ब्रह्मांड के रहस्य" का विमोचन किया गया।</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2.5 flex-shrink-0" />
                    <span>समाज को <strong>अन्य पिछड़ा वर्ग</strong> में शामिल कराये जाने की मांग पर चर्चा हुयी।</span>
                  </li>
                </ul>
                <p>
                  मुख्य विचारणीय विषय विधान संशोधन रहा। पंजीकृत विधान को पुराने विधान के अनुसार संशोधित करने हेतु प्रस्ताव रखे गये। चर्चा हुयी। कुछ संशोधनों पर विरोध भी हुआ, लेकिन संशोधन पारित किये गये।
                </p>
              </div>

              {/* Download Amended Constitution - Coming Soon */}
              <div className="bg-white/80 p-4 rounded-lg mt-6">
                <div className="flex items-center gap-3 mb-2">
                  <FileText className="w-5 h-5 text-primary" />
                  <span className="text-gray-700 font-medium">संशोधित विधान 2025</span>
                </div>
                <p className="text-sm text-gray-500 mb-3">विधान संशोधन की प्रक्रिया जारी है। संशोधित विधान जल्द ही उपलब्ध होगा।</p>
                <Button variant="outline" size="sm" className="border-gray-300 text-gray-400 cursor-not-allowed" disabled>
                  <Download className="w-4 h-4 mr-2" /> जल्द उपलब्ध होगा
                </Button>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Future Plans Section */}
        <motion.section
          id="future"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-2 section-heading">
            भविष्य की योजनायें
          </h2>
          <p className="text-gray-500 mb-8">Future Plans</p>

          <div className="bg-gradient-to-br from-blue-50 to-transparent rounded-2xl border border-blue-100 p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-blue-600" />
              </div>
              <p className="text-gray-600">
                संशोधित विधान के अनुसार सदस्य बनाने व कामकाज आगे बढाने को सतत क्रियाशील हैं।
              </p>
            </div>

            <div className="grid gap-3">
              {futurePlans.map((plan, index) => (
                <div key={index} className="flex items-start gap-3 bg-white/80 p-4 rounded-lg">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{plan}</span>
                </div>
              ))}
            </div>
          </div>
        </motion.section>

        {/* Call to Action */}
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="gradient-dark rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              इस प्रकार महासभा लक्ष्यप्राप्ति की ओर अग्रसर है।
            </h2>
            <p className="text-xl text-white/90 mb-6">
              सभी का सहयोग आमंत्रित है।
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button 
                size="lg" 
                className="bg-white text-primary hover:bg-white/90"
                onClick={() => window.location.href = '/members'}
              >
                <Users className="w-5 h-5 mr-2" />
                सदस्य बनें
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="border-white text-white hover:bg-white/10"
                onClick={() => window.location.href = '/contact'}
              >
                संपर्क करें
              </Button>
            </div>
          </div>
        </motion.section>

      </div>
    </div>
  );
};

export default HistoryPage;
